import { cloudApi } from '../api/index';
import { formatTime, ROOM_TYPE, toFixed } from '../base/CONST';
const { getCloudOrderDetails } = cloudApi;
const ORDER_TYPE = ['', '购买', '升级/续费'];
const ORDER_STATE = ['', '未支付', '已支付'];
export default {
  data() {
    return {
      order: null,
      list: [],
    };
  },
  created() {
    this.order = this.$route.params.order;
    console.log('orderDetails created---', this.order);
    if (!this.order) {
      const hashs = location.hash.split('/');
      if (hashs && hashs.length) {
        this.order = { id: hashs[hashs.length - 1] };
      }
    }
    if (!this.order) return console.warn('页面路由出错');
    getCloudOrderDetails({ id: this.order.id }).then(res => {
      // ori_money 原价 money 实付价
      this.order = res.data;
      this.order.subMoney = toFixed(this.order.ori_money - this.order.money);
      this.order.ori_money = toFixed(this.order.ori_money);
      this.order.money = toFixed(this.order.money);
      this.list = res.data.list;
    });
  },
  filters: {
    orderType: function (type) {
      return ORDER_TYPE[type];
    },
    orderState: function (state) {
      return ORDER_STATE[state];
    },
    formatTime(time) {
      return formatTime(time, true);
    },
    roomType(type) {
      return ROOM_TYPE[type];
    },
  },
};
